import { ShortcutManager } from "./ShortcutManager";
import { IShortcutManager } from "./interfaces/IShortcutManager";

export const createShortcutManagerInstance = (element: HTMLElement): IShortcutManager => {
    const manager = new ShortcutManager(element, navigator.userAgent.includes("Mac"));
    manager.enableListeners();

    return manager;
};
